// 挂法安装视频（How to Hang）+ 配件数量说明。数据和抽屉结构见 snippets/header-type-popup.liquid。
// - 挂法标题行右侧「How to Hang」：产品有任一挂法配了视频就出现；打开抽屉并展开当前选中的挂法（选中的没视频就只列出全部）
// - 抽屉里是这个产品所有有视频的挂法（折叠面板），一次只展开一个、只放一个视频
// - 挂法色块下面一行配件数量说明（元对象 included_note）：手机没有悬停浮窗，靠这行看到
// 选中挂法 → 它的浮窗（attachHeaderTypePopups 已按标题挂到色块上）→ 浮窗上的 data-guide / 说明，
// 不在这里重复写一遍挂法名匹配规则。
(() => {
  if (window.thehuesHeaderGuide) return;
  window.thehuesHeaderGuide = true;

  const HEADER_INPUT = 'input[name="properties[Header Type]"]';
  // 和 snippets/header-guide-play-icon.liquid 同一个图标
  const PLAY_ICON = '<svg class="headerGuide__icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7.25" stroke="currentColor" stroke-width="1.2"/><path d="M6.5 5.4v5.2L10.8 8 6.5 5.4Z" fill="currentColor"/></svg>';
  const NOTE_ICON = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.2"/><path d="M8 7v4M8 4.5v1" stroke="currentColor" stroke-width="1.2"/></svg>';

  const guide = document.querySelector('[data-header-guide]');
  // 抽屉渲染在产品区里；挪到 body 下，避免祖先的 transform / overflow 影响 fixed 定位
  if (guide && guide.parentElement !== document.body) document.body.appendChild(guide);

  const mainRoot = () => document.querySelector('#bcpo:not(.g-card)');

  // 主产品区里选项值对应的浮窗：优先拿挂在色块上的那个；被别处挪走时按标题兜底
  function popupFor(input) {
    const item = input?.closest('.bcpo-image-parent');
    const own = item?.querySelector(':scope > .headerTypePopup');
    if (own) return own;
    const value = (input?.value || '').trim().toLowerCase();
    if (!value) return null;
    return Array.from(document.querySelectorAll('.headerTypePopup')).find((popup) => {
      const title = (popup.dataset.title || '').trim().toLowerCase();
      return title && (value.endsWith(title) || title.endsWith(value) || value.split(/\s+[—–]\s+/)[0] === title);
    }) || null;
  }

  // 这个产品开放的、配了视频的挂法（按产品页色块顺序）。元对象是全站的，产品可能只开放其中几种
  function offeredGuides() {
    const ids = [];
    mainRoot()?.querySelectorAll(HEADER_INPUT).forEach((input) => {
      const id = popupFor(input)?.dataset.guide;
      if (id && !ids.includes(id) && guide && document.getElementById(id)) ids.push(id);
    });
    return ids;
  }

  // ---------- 挂法标题行入口 + 色块下面的说明 ----------
  function sync() {
    const root = mainRoot();
    const input = root?.querySelector(HEADER_INPUT);
    if (!input) return;
    const wrapper = input.closest('.selector-wrapper');
    const label = wrapper?.querySelector(':scope > .bcpo-label');
    if (!wrapper || !label) return;
    const checked = root.querySelector(`${HEADER_INPUT}:checked`);
    const popup = checked ? popupFor(checked) : null;

    // 有视频的挂法里只要这个产品开放了任一个，就给入口；data-header-guide-open 指向选中的那个（可能为空）
    const offered = offeredGuides();
    const selectedId = popup?.dataset.guide && offered.includes(popup.dataset.guide) ? popup.dataset.guide : '';
    let link = label.querySelector(':scope > .header-guide-link');
    if (offered.length && !link) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = 'header-guide-link';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', 'Installation Guide: installation videos');
      link.textContent = 'Installation Guide';
      label.appendChild(link);
    }
    if (link) {
      link.hidden = !offered.length;
      if (link.dataset.headerGuideOpen !== selectedId || !link.hasAttribute('data-header-guide-open')) {
        link.dataset.headerGuideOpen = selectedId;
        link.setAttribute('click-data', `HeaderGuide-open-${checked?.value.trim() || 'none'}`);
      }
    }

    const source = popup?.querySelector('[data-included-note]');
    let note = wrapper.querySelector(':scope > .header-included-note');
    // 没有说明就整行移除，不用 hidden：折叠式模板（page_product_gallery-sizeType.css）会用 !important 把标题后的兄弟元素改成 flex
    if (!source) {
      note?.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'header-included-note';
      note.innerHTML = `${NOTE_ICON}<span></span>`;
      const group = wrapper.querySelector(':scope > .single-option-selector');
      (group || label).after(note);
    }
    const text = note.querySelector('span');
    if (text.innerHTML !== source.innerHTML) text.innerHTML = source.innerHTML;
  }

  // BCPO 异步生成选项，bcpoLoad 之后还会改名重挂浮窗：观察主产品区，合并成一次再同步（sync 幂等，不会自激）。
  // 用 setTimeout 不用 requestAnimationFrame：后台标签页里 rAF 不触发，切回来时说明行会是旧的
  let queued = false;
  const queueSync = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; sync(); }, 0);
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches?.(HEADER_INPUT)) queueSync();
  });
  let observed = null;
  const observeRoot = () => {
    const root = mainRoot();
    if (!root || root === observed) return;
    observed = root;
    new MutationObserver(queueSync).observe(root, { childList: true, subtree: true });
    queueSync();
  };
  observeRoot();
  if (!observed) {
    const waitForRoot = new MutationObserver(() => {
      observeRoot();
      if (observed) waitForRoot.disconnect();
    });
    waitForRoot.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!guide) return;

  // ---------- 抽屉 ----------
  const box = guide.querySelector('.popupBox');
  const body = guide.querySelector('[data-header-guide-body]');
  const list = guide.querySelector('.headerGuide__items');
  const closeButton = guide.querySelector('[data-header-guide-close]');
  const items = () => Array.from(guide.querySelectorAll('[data-header-guide-item]'));
  const contentOf = (item) => item.querySelector('.headerGuide__content');
  const toggleOf = (item) => item.querySelector('[data-header-guide-toggle]');

  function youTubeEmbed(url) {
    let id = '';
    try {
      const parsed = new URL(url);
      const host = parsed.hostname.replace(/^(www|m)\./, '');
      if (host === 'youtu.be') id = parsed.pathname.split('/')[1] || '';
      else if (/^youtube(-nocookie)?\.com$/.test(host)) {
        id = parsed.searchParams.get('v') || (parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/?#]+)/) || [])[1] || '';
      }
    } catch (_) {}
    if (!/^[\w-]{6,20}$/.test(id)) return '';
    return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  }

  // 同一个 Shopify 视频只建一个播放器；跨挂法移动节点，不重新选源或下载。
  const nativePlayers = new Map();
  const playAttempts = new WeakMap();
  function nativeKey(stage, template) {
    if (stage.dataset.headerGuideVideoId) return `id:${stage.dataset.headerGuideVideoId}`;
    // 兼容尚未更新的 Liquid 缓存；完整源地址相同才复用，没有源的节点不合并。
    const media = template.content.querySelector('video');
    const sources = [media, ...template.content.querySelectorAll('source')]
      .filter((node) => node?.getAttribute('src'))
      .map((node) => [new URL(node.getAttribute('src'), document.baseURI).href, node.getAttribute('type') || '']);
    return sources.length ? `src:${JSON.stringify(sources)}` : '';
  }

  // 收起或关闭时停掉（YouTube iframe 直接移除，不留后台声音）
  function stopMedia(item) {
    item.querySelectorAll('video').forEach((video) => {
      playAttempts.set(video, (playAttempts.get(video) || 0) + 1);
      video.pause();
    });
    item.querySelectorAll('[data-header-guide-stage]').forEach((stage) => stage.classList.remove('is-loading'));
    item.querySelectorAll('iframe').forEach((frame) => frame.remove());
  }

  // 一个挂法可能有多段视频（标题按钮切换，snippets/header-type-popup.liquid）：放当前没隐藏的那段
  const activeStage = (item) => item.querySelector('[data-header-guide-stage]:not([hidden])') || item.querySelector('[data-header-guide-stage]');

  function startMedia(item, autoplay) {
    const stage = activeStage(item);
    if (!stage) return;
    let video = stage.querySelector('video');
    const template = stage.querySelector('template[data-header-guide-video]');
    if (!video && template) {
      const key = nativeKey(stage, template);
      video = key && nativePlayers.get(key);
      if (video) {
        video.closest('[data-header-guide-stage]')?.classList.remove('is-loading');
        stage.appendChild(video);
        // 名称跟随当前挂法/片段，不能继续引用上一个挂法的标题。
        const model = template.content.querySelector('video');
        ['aria-labelledby', 'aria-label'].forEach((name) => {
          if (model.hasAttribute(name)) video.setAttribute(name, model.getAttribute(name));
          else video.removeAttribute(name);
        });
      } else {
        stage.appendChild(template.content.cloneNode(true));
        video = stage.querySelector('video');
        if (video) {
          if (key) nativePlayers.set(key, video);
          // Safari 首次插入后显式选源；后续移动/重开保留缓冲和播放位置。
          video.load();
        }
      }
    }
    if (video) {
      // 网速慢时视频停在首帧等数据，看起来像卡死（iPhone 真机实测）：缓冲期间在视频中间转圈，开播/暂停/出错就收起
      if (!video.dataset.guideLoading) {
        video.dataset.guideLoading = 'true';
        const busy = (on) => video.closest('[data-header-guide-stage]')?.classList.toggle('is-loading', on);
        video.addEventListener('waiting', () => busy(true));
        video.addEventListener('playing', () => busy(false));
        video.addEventListener('pause', () => busy(false));
        video.addEventListener('error', () => busy(false));
      }
      if (autoplay) {
        const attempt = (playAttempts.get(video) || 0) + 1;
        playAttempts.set(video, attempt);
        if (video.readyState < 3) stage.classList.add('is-loading');
        video.play().catch(() => {
          if (playAttempts.get(video) === attempt) stage.classList.remove('is-loading');
        });
      }
      return;
    }
    const url = stage.dataset.youtube;
    if (!url) return;
    const src = youTubeEmbed(url);
    if (!src) {
      // 不是能嵌入的 YouTube 链接：给一个新标签页打开的按钮，不让播放区空着
      if (!stage.querySelector('a')) {
        const external = document.createElement('a');
        external.className = 'headerGuide__external';
        external.href = url;
        external.target = '_blank';
        external.rel = 'noopener';
        external.innerHTML = `${PLAY_ICON}<span>Watch video</span>`;
        stage.appendChild(external);
      }
      return;
    }
    const frame = document.createElement('iframe');
    frame.src = autoplay ? src : src.replace('autoplay=1', 'autoplay=0');
    frame.title = `Installation Guide: ${item.querySelector('.headerGuide__name')?.textContent.trim() || ''}`.trim();
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    stage.appendChild(frame);
  }

  function setExpanded(item, open) {
    toggleOf(item)?.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-expanded', open);
    const content = contentOf(item);
    if (content) content.hidden = !open;
    if (!open) stopMedia(item);
  }

  // 把这一行滚到抽屉内容区顶部（只滚抽屉自己，不用 scrollIntoView：抽屉滑入时还在屏外，会连带滚动被锁住的页面）。
  // 上面还有别的挂法时露出上一行的一截（PEEK），提示往上还能看
  const PEEK = 24;
  function scrollToItem(item, smooth) {
    if (!body) return;
    const offset = item.getBoundingClientRect().top - body.getBoundingClientRect().top;
    const hasPrevious = items().some((other) => !other.hidden && other !== item && (item.compareDocumentPosition(other) & Node.DOCUMENT_POSITION_PRECEDING));
    const top = body.scrollTop + offset - (parseFloat(getComputedStyle(body).paddingTop) || 0) - (hasPrevious ? PEEK : 0);
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (typeof body.scrollTo === 'function') body.scrollTo({ top: Math.max(0, top), behavior: smooth && !reduced ? 'smooth' : 'auto' });
    else body.scrollTop = Math.max(0, top);
  }

  // 一次只展开一个：展开这个、收起其他（同时停掉其他视频）
  function expand(id, { autoplay = false, smooth = false } = {}) {
    const target = items().find((item) => item.id === id && !item.hidden);
    items().forEach((item) => { if (item !== target) setExpanded(item, false); });
    if (!target) return;
    setExpanded(target, true);
    scrollToItem(target, smooth);
    startMedia(target, autoplay);
  }

  // 只列这个产品开放的挂法，顺序跟产品页色块一致；标出当前选中的那个
  function prepareItems(selectedId) {
    const offered = offeredGuides();
    items().forEach((item) => {
      item.hidden = offered.length > 0 && !offered.includes(item.id);
      item.classList.toggle('is-selected', item.id === selectedId);
    });
    offered.forEach((id) => {
      const item = document.getElementById(id);
      if (item && list) list.appendChild(item);
    });
    // 标题下的提示：告诉用户这里有全部挂法的视频，点哪个看哪个
    const hint = guide.querySelector('[data-header-guide-hint]');
    const count = items().filter((item) => !item.hidden).length;
    if (hint) {
      hint.hidden = count < 2;
      hint.textContent = `${count} header styles · tap any to watch`;
    }
  }

  function closeGuide() {
    items().forEach(stopMedia);
    if (typeof setThemeGuideOpen === 'function') setThemeGuideOpen(guide, false);
    else guide.classList.remove('active', 'is-open');
  }

  function openGuide(id, opener) {
    const checked = mainRoot()?.querySelector(`${HEADER_INPUT}:checked`);
    prepareItems(checked ? popupFor(checked)?.dataset.guide : '');
    if (typeof setThemeGuideOpen === 'function') {
      setThemeGuideOpen(guide, true, opener, { closeControl: closeButton, label: 'Installation Guide', close: closeGuide });
    } else {
      guide.classList.add('active', 'is-open');
      closeButton?.focus();
    }
    // 从某个挂法进来：展开它并直接带声音播放（用户点击触发，浏览器拒绝时停在封面，控件可手动点）。
    // 选中的挂法没视频（入口 id 为空）：全部收起，列表从头看
    const visible = items().filter((item) => !item.hidden);
    const target = visible.find((item) => item.id === id) || (visible.length === 1 ? visible[0] : null);
    if (target) expand(target.id, { autoplay: true });
    else {
      items().forEach((item) => setExpanded(item, false));
      if (body) body.scrollTop = 0;
    }
  }

  // 原生播放器内部的按钮/时间滑块由浏览器处理 Tab；共享焦点圈只看得到外层 video，
  // 会提前跳到下一个挂法。先保留原生导航，再补回离开文档（没有 focusin）的边界。
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && guide.classList.contains('is-open') &&
        event.target?.matches?.('video[controls]') && guide.contains(event.target)) {
      const video = event.target;
      const reverse = event.shiftKey;
      event.stopImmediatePropagation();
      // WebKit 的原生控件可能直接退到浏览器工具栏 / body，不触发面板的 focusin。
      // 默认动作完成后才判断；仍在视频内部或面板里的焦点完全交给浏览器。
      setTimeout(() => {
        if (!guide.classList.contains('is-open') || !video.isConnected ||
            guide.contains(document.activeElement)) return;
        const controls = typeof getFocusableElements === 'function' ? getFocusableElements(box) : [];
        const index = controls.indexOf(video);
        const next = index < 0 ? closeButton : controls[(index + (reverse ? -1 : 1) + controls.length) % controls.length];
        next?.focus({ preventScroll: true });
      }, 0);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-header-guide-open]');
    if (!trigger) return;
    event.preventDefault();
    // 浮窗里的按钮：浮窗关掉后不可见，焦点还给对应的挂法色块
    const opener = trigger.closest('.headerTypePopup')
      ? trigger.closest('.bcpo-image-parent')?.querySelector('label.bcpo-front-image-label') || trigger
      : trigger;
    openGuide(trigger.dataset.headerGuideOpen, opener);
  });
  closeButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeGuide();
  });
  guide.addEventListener('click', (event) => {
    if (event.target === guide) closeGuide();
  });
  // 点标题行：收起的就展开并播放、滚到顶；已展开的就收起
  // 多段视频的标题按钮：切到这段，停掉其它段（YouTube iframe 移除），用户点击直接带声音播放；收起再展开仍是这段
  function selectClip(item, stageId, autoplay) {
    item.querySelectorAll('[data-header-guide-clip]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.headerGuideClip === stageId ? 'true' : 'false');
    });
    item.querySelectorAll('[data-header-guide-stage]').forEach((stage) => {
      const show = stage.id === stageId;
      if (!show) {
        stage.querySelectorAll('video').forEach((video) => video.pause());
        stage.querySelectorAll('iframe').forEach((frame) => frame.remove());
      }
      stage.hidden = !show;
    });
    startMedia(item, autoplay);
  }

  // 配件沿用现有 Quick Buy / CartEditor，不让两个弹窗的焦点圈互相抢焦点。
  // 安装面板保留当前挂法、片段和滚动位置；取消/加载失败后恢复，进入购物车则收起。
  guide.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-quick-buy-open], [data-cart-add]');
    if (!link || !guide.classList.contains('is-open') || link.disabled ||
        event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (typeof finishThemeGuide !== 'function' || typeof prepareThemeGuide !== 'function') return;
    items().forEach(stopMedia);
    finishThemeGuide(guide);
    guide.inert = true;
    guide.setAttribute('aria-hidden', 'true');
    const modalId = link.dataset.quickBuyOpen;
    let scheduled = false;
    const checkHardware = () => {
      if (scheduled) return;
      scheduled = true;
      // Quick Buy 的 finally 先移除 busy，随后才挂载弹窗；等同一轮异步操作结束再判断。
      setTimeout(() => {
        scheduled = false;
        const modal = modalId ? document.getElementById(modalId) : document.querySelector('dialog.cart-editor[open]');
        if (guide.isConnected && (link.getAttribute('aria-busy') === 'true' ||
            (modal && (modal.hasAttribute('open') || (!modal.hidden && modal.classList.contains('qb-modal--open')))))) return;
        observer.disconnect();
        guide.inert = false;
        guide.removeAttribute('aria-hidden');
        if (!guide.isConnected) return;
        if (document.querySelector('cart-drawer.active')) {
          closeGuide();
          return;
        }
        if (guide.classList.contains('is-open')) {
          prepareThemeGuide(guide, box, document.querySelector('.header-guide-link'), {
            closeControl: closeButton, label: 'Installation Guide', close: closeGuide
          });
          document.body.classList.add('theme-guide-scroll-locked');
          link.focus({ preventScroll: true });
        }
      }, 0);
    };
    const observer = new MutationObserver(checkHardware);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'hidden', 'open', 'aria-busy'] });
    checkHardware();
  });

  box?.addEventListener('click', (event) => {
    const clip = event.target.closest('[data-header-guide-clip]');
    if (clip) {
      const clipItem = clip.closest('[data-header-guide-item]');
      if (clipItem && clip.getAttribute('aria-pressed') !== 'true') selectClip(clipItem, clip.dataset.headerGuideClip, true);
      return;
    }
    const toggle = event.target.closest('[data-header-guide-toggle]');
    const item = toggle?.closest('[data-header-guide-item]');
    if (!item) return;
    if (item.classList.contains('is-expanded')) setExpanded(item, false);
    else expand(item.id, { autoplay: true, smooth: true });
  });
})();
